import React, { useEffect, useState } from "react";

import {
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    CircularProgress,
} from "@mui/material";
import { CheckCircle, RadioButtonUnchecked, FlightRounded } from "@mui/icons-material";

import { useSetRecoilState } from "recoil";
import { snackbarData } from "recoilState/GlobalState";

import { migraUsuarioPasoUpd, migraUsuarioPasoVueloGet } from "services/services-mia/migra";
import { handleResponse } from "services/Local-services";
import { FormButton } from "components";

import styles from "styles/pages/ModalActions.module.scss";
import vueloStyles from "./VueloDetalleModal.module.scss";

const esSalida = (migraUsuarioPasoTipo) => migraUsuarioPasoTipo === "S";

const origenDestinoDeVuelo = (vuelo, migraUsuarioPasoTipo) =>
    esSalida(migraUsuarioPasoTipo) ? vuelo.vueloDestino : vuelo.vueloOrigen;

const formatFechaHora = (value) => {
    if (!value) return "";
    const fecha = new Date(value);
    if (Number.isNaN(fecha.getTime())) return value;
    return fecha.toLocaleString().replace(",", "");
};

export default function VueloModal({ row, updateList, closeModal, credentials, setRowSelected }) {
    const [loading, setLoading] = useState(true);
    const [inRequest, setInRequest] = useState(false);
    const [vuelos, setVuelos] = useState([]);
    const [seleccionado, setSeleccionado] = useState(row.migraUsuarioPasoIdentificacion || "");
    const setSnackbarInfo = useSetRecoilState(snackbarData);

    useEffect(() => {
        (async () => {
            const response = await migraUsuarioPasoVueloGet(
                { migraUsuarioPasoId: row.migraUsuarioPasoId },
                credentials
            );

            if (response?.status?.code === 1) {
                setVuelos(response.result || []);
            } else {
                setSnackbarInfo({
                    message: response?.status?.errmsg || "No se pudieron obtener los vuelos",
                    severity: "error",
                    open: true,
                });
            }
            setLoading(false);
        })();
    }, [row.migraUsuarioPasoId, credentials, setSnackbarInfo]);

    const vueloActual = vuelos.find(
        (vuelo) => vuelo.vueloIdentificacion === row.migraUsuarioPasoIdentificacion
    );
    const vuelosSeleccionables = vuelos.filter(
        (vuelo) => vuelo.vueloIdentificacion !== row.migraUsuarioPasoIdentificacion
    );

    const handleSubmit = async () => {
        setInRequest(true);

        const vuelo = vuelos.find((v) => v.vueloIdentificacion === seleccionado);
        const migraUsuarioPasoIdentificacion = vuelo ? vuelo.vueloIdentificacion : null;
        const migraUsuarioPasoOrigenDestino = vuelo
            ? origenDestinoDeVuelo(vuelo, row.migraUsuarioPasoTipo)
            : null;

        const response = await migraUsuarioPasoUpd(
            {
                migraUsuarioPasoId: row.migraUsuarioPasoId,
                migraUsuarioPasoSemaforo: row.migraUsuarioPasoSemaforo,
                migraUsuarioPasoIdentificacion,
                migraUsuarioPasoOrigenDestino,
            },
            credentials
        );
        handleResponse(response, "Vuelo asignado exitosamente", {
            setSnackbarInfo,
            setInRequest,
            setIsOpen: closeModal,
            setSelected: setRowSelected,
            updateList,
        });
    };

    if (loading) {
        return (
            <div className={styles.inputs} style={{ display: "flex", justifyContent: "center" }}>
                <CircularProgress size={28} />
            </div>
        );
    }

    return (
        <div className={styles.inputs}>
            {vueloActual && (
                <section className={vueloStyles.section} style={{ marginBottom: "1.5rem" }}>
                    <h4 className={vueloStyles.sectionTitle}>
                        <FlightRounded /> Vuelo actual
                    </h4>
                    <div className={vueloStyles.passengersWrap}>
                        <table className={vueloStyles.passengersTable}>
                            <thead>
                                <tr>
                                    <th>Identificación</th>
                                    <th>Origen</th>
                                    <th>Destino</th>
                                    <th>Fecha</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{vueloActual.vueloIdentificacion}</td>
                                    <td>{vueloActual.vueloOrigen}</td>
                                    <td>{vueloActual.vueloDestino}</td>
                                    <td>{formatFechaHora(vueloActual.vueloFechaHora)}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
            )}

            <List style={{ width: "100%", maxHeight: "40vh", overflowY: "auto" }}>
                <ListItemButton
                    selected={!seleccionado}
                    onClick={() => setSeleccionado("")}
                >
                    <ListItemIcon>
                        {!seleccionado ? <CheckCircle color="success" /> : <RadioButtonUnchecked />}
                    </ListItemIcon>
                    <ListItemText primary="Ninguno" />
                </ListItemButton>

                {vuelosSeleccionables.map((vuelo) => {
                    const isSelected = seleccionado === vuelo.vueloIdentificacion;
                    return (
                        <ListItemButton
                            key={vuelo.vueloIdentificacion}
                            selected={isSelected}
                            onClick={() => setSeleccionado(vuelo.vueloIdentificacion)}
                        >
                            <ListItemIcon>
                                {isSelected ? <CheckCircle color="success" /> : <RadioButtonUnchecked />}
                            </ListItemIcon>
                            <ListItemText
                                primary={`${vuelo.vueloIdentificacion} — ${vuelo.vueloOrigen} → ${vuelo.vueloDestino}`}
                                secondary={formatFechaHora(vuelo.vueloFechaHora)}
                            />
                        </ListItemButton>
                    );
                })}
            </List>

            <div className={styles["column-sm"]}>
                <FormButton
                    inRequest={inRequest}
                    newFormData={{ button: "Guardar" }}
                    onCloseModal={closeModal}
                    onClick={handleSubmit}
                />
            </div>
        </div>
    );
}
